import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import components from "@ali/zr-material-components";
import "./index.scss";
// import { mock } from "../mock";

export default function ZrRenderer(props) {
  // mock数据调试使用
  // const { zhurong, isSuperFactory } = mock;
  var zhurong = props.zhurong,
    isSuperFactory = props.isSuperFactory,
    loginId = props.loginId,
    isPcSem = props.isPcSem;
  var templateId = zhurong.templateId,
    modules = zhurong.modules,
    global_attr = zhurong.global_attr;
  var eurl = global_attr.eurl,
    pid = global_attr.pid,
    session_id = global_attr.session_id,
    adgroup_id = global_attr.adgroup_id;
  var _modules$filter = modules.filter(function (item) {
      return item.componentName === "Title";
    }),
    title = _modules$filter[0];
  var titleBlockId = title === null || title === void 0 ? void 0 : title.blockId;
  var titleData = zhurong[titleBlockId];
  try {
    var hasZrValue = !!zhurong && Object.keys(zhurong).length !== 0;
    if (!hasZrValue) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "zr-render-container"
      }, /*#__PURE__*/React.createElement("a", {
        href: eurl,
        target: "_blank"
      }, (modules === null || modules === void 0 ? void 0 : modules.length) > 0 && modules.map(function (item, index) {
        // 主搜右侧使用带广告标的图片
        var name = pid === "819036_1008" && item.componentName === "MainPic" ? "MainPicWithAd" : item.componentName;
        var Comp = components[name];
        var compProps = _extends({
          eurl: eurl,
          pid: pid,
          session_id: session_id,
          adgroup_id: adgroup_id,
          templateId: templateId,
          blockId: item.blockId,
          titleData: titleData,
          isSuperFactory: isSuperFactory,
          isPcSem: isPcSem,
          loginId: loginId
        }, zhurong[item.blockId]);
        return /*#__PURE__*/React.createElement(Comp, _extends({}, compProps, {
          key: index
        }));
      })));
    }
  } catch (e) {
    console.log(e);
    return null;
  }
}